import { ISalesrepsPayload } from 'app/models/salesreps';
import axiosInstance from './axiosInstance';

const GET_SALESREPS = `/erp/salesreps`;

export async function getSalesReps(): Promise<{ data: ISalesrepsPayload[] }> {
    return await axiosInstance.get(GET_SALESREPS);
}
